


.about{

  &.open > div {
    max-height: max-content;

    &:after {
      display: none;
    }
  }

  & > div {
    position: relative;
    max-height: 275px;
    overflow: hidden;

    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 150px;
      background-image: linear-gradient(0deg, #FFFFFF 7%, rgba(255, 255, 255, 0) 100%);
    }
  }
}


